import { createSelector } from 'reselect'

export const getRegistrationLoading = createSelector(
  state => Boolean(state && state.user && state.user.registration && state.user.registration.isLoading),
  isLoading => isLoading
)
